import { render, staticRenderFns } from "./coletaBiometria.vue?vue&type=template&id=79522a25"
import script from "./coletaBiometria.vue?vue&type=script&lang=js"
export * from "./coletaBiometria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports